// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import strip from 'strip-comments';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';
//import { initReactI18next } from 'react-i18next';
const reactI18nextModule = require('react-i18next');

// Function to set dir attribute on html element
function setHtmlDirection() {
    document.documentElement.setAttribute('dir', 'ltr');
}

i18n.use(XHR)
    .use(LanguageDetector)
    .use(reactI18nextModule.initReactI18next)
    .init({
        backend: {
            loadPath: (lang: string, ns: string): string => {
                return `/language/${lang}/${ns}.json`;
            },
            parse: (data: any) => {
                const dataCleaned = strip(data);
                return JSON.parse(dataCleaned);
            },
        },
        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
            lookupQuerystring: 'language',
            lookupLocalStorage: 'language',
            caches: ['localStorage'],
        },
        fallbackLng: 'en',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            wait: true,
        },
        defaultNS: 'translation',
        ns: ['translation', 'lists', 'faqTranslation'],
    });

// Set initial direction
setHtmlDirection();

export default i18n;
